import { createEntityAdapter, createSelector as reduxCreateSelector } from '@reduxjs/toolkit';

import { StoreSchema } from '@/app/providers/store';
import { createSelector } from '@/shared/lib/helpers/create-store-logic';
import { getCurrentDomain } from '@/shared/lib/helpers/get-domain-from-pathname.helper';

import { boatApi } from '../../api/boat.api';
import { BoatSearch } from '../types/boat.interface';

const EMPTY_BOATS: BoatSearch[] = [];
const EMPTY_BOAT: BoatSearch = { name: '', id: '', mmsi: '', uuid: '', imageUrl: '' };
const boatsAdapter = createEntityAdapter<BoatSearch>({
	selectId: (boat) => boat.id,
});
const initialBoatState = boatsAdapter.getInitialState();

const selectUserBoats = (state: StoreSchema) => {
	const userId = state.user.data?.id || '';
	const domain = getCurrentDomain();
	const { data } = boatApi.endpoints.getUserBoats.select({ userId, domain })(state);

	return data ?? EMPTY_BOATS;
};

const selectUserBoatsState = reduxCreateSelector(selectUserBoats, (boats) =>
	boatsAdapter.setAll(initialBoatState, boats),
);

export const selectBoat = boatsAdapter.getSelectors<StoreSchema>(selectUserBoatsState);

export const [useSelectedBoat] = createSelector((state) => selectBoat.selectById(state, state.boat.selectedId || ''));

export const [useBoatById] = createSelector((state, id: string) => selectBoat.selectById(state, id) ?? EMPTY_BOAT);

export const [useIsSelectBoat] = createSelector((state) => Boolean(state.boat.selectedId));

export const [useBoatLength] = createSelector((state) => selectBoat.selectTotal(state));
export const [useHasMultipleEntities] = createSelector((state) => selectBoat.selectTotal(state) > 1);

export const [useFirstBoat] = createSelector((state) => selectBoat.selectAll(state)[0]);
